import http from "./http";

function getWheelType(data) {
    return http.post(`vehicleWheelList`, data);
  }
  function addWheelType(data) {
    return http.post(`addVehicleWheel`, data);
  }
  function updateWheelType(data) {
    return http.post(`updateVehicleWheel`, data);
  }
  function deleteWheelType(data) {
    return http.post(`deleteVehicleWheel`, data);
  }

  const WheelTypeService = {
    getWheelType,
    addWheelType,
    updateWheelType,
    deleteWheelType,
  };
  
  export default WheelTypeService;